<template>
  <div>
    <div v-if="loading" class="text-center my-4"><b-spinner></b-spinner></div>
    <div v-else-if="!data">
      <b-alert show variant="warning">No se pudo cargar la vista 360°.</b-alert>
    </div>
    <div v-else>
      <!-- KPIs -->
      <b-row class="mb-3">
        <b-col md="3" sm="6" class="mb-2">
          <kpi-card label="Compras" :value="num(kpis.orders)" format="number" />
        </b-col>
        <b-col md="3" sm="6" class="mb-2">
          <kpi-card label="Gasto de por vida" :value="num(kpis.lifetime_spend)" format="money" />
        </b-col>
        <b-col md="3" sm="6" class="mb-2">
          <kpi-card label="Ticket promedio" :value="num(kpis.avg_ticket)" format="money" />
        </b-col>
        <b-col md="3" sm="6" class="mb-2">
          <kpi-card label="Puntos" :value="num(loyalty.points_balance)" format="number" />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6" class="mb-3">
          <b-card title="Lealtad" body-class="py-2">
            <p class="mb-1"><strong>Saldo:</strong> {{ num(loyalty.points_balance) }} pts
              (<span class="text-muted">pendiente {{ num(loyalty.points_pending) }}</span>)</p>
            <p class="mb-1"><strong>Nivel:</strong> {{ loyalty.tier_id || '—' }}
              <span v-if="loyalty.points_to_next_tier"> · faltan {{ num(loyalty.points_to_next_tier) }} para el siguiente</span>
            </p>
          </b-card>
        </b-col>
        <b-col md="6" class="mb-3">
          <b-card title="Beneficios" body-class="py-2">
            <b-table small striped :items="benefits" :fields="benefitFields" show-empty
              empty-text="Sin beneficios."></b-table>
          </b-card>
        </b-col>
      </b-row>

      <b-card title="Referidos" class="mb-3" body-class="py-2">
        <b-table small striped :items="referrals" :fields="referralFields" show-empty
          empty-text="Sin referidos."></b-table>
      </b-card>

      <b-card title="Historial de compras" class="mb-3" body-class="py-2">
        <b-table small striped :items="history" :fields="historyFields" show-empty
          empty-text="Sin historial.">
          <template #cell(total)="d">{{ money(d.item.total) }}</template>
        </b-table>
      </b-card>

      <!-- Bloques Fase 5 diferida: encuestas, casos y eventos. Ocultos por feature_disabled. -->
      <b-alert v-if="fase5Diferida" show variant="light" class="small">
        Encuestas, casos y taquizas del cliente: <strong>Fase 5 diferida</strong>.
      </b-alert>
    </div>
  </div>
</template>

<script>
import KpiCard from './KpiCard.vue';
import executiveService from '@/services/executiveService';

// Vista 360° del cliente (doc 04 §4). Los bloques surveys/cases/events se ocultan
// cuando el backend responde feature_disabled (Fase 5 diferida).
export default {
  name: 'Customer360',
  components: { KpiCard },
  props: {
    customerId: { type: [Number, String], required: true }
  },
  data() {
    return {
      loading: false,
      data: null,
      benefitFields: [
        { key: 'code', label: 'Código' },
        { key: 'name', label: 'Beneficio' },
        { key: 'status', label: 'Estatus' },
        { key: 'expires_at', label: 'Vence' }
      ],
      referralFields: [
        { key: 'referred_name', label: 'Referido' },
        { key: 'status', label: 'Estatus' },
        { key: 'registered_at', label: 'Fecha' }
      ],
      historyFields: [
        { key: 'date', label: 'Fecha' },
        { key: 'channel_label', label: 'Canal' },
        { key: 'sucursal_id', label: 'Sucursal' },
        { key: 'total', label: 'Total' },
        { key: 'points_earned', label: 'Puntos' }
      ]
    };
  },
  computed: {
    kpis() { return (this.data && this.data.kpis) || {}; },
    loyalty() { return (this.data && this.data.loyalty) || {}; },
    benefits() { return (this.data && this.data.benefits) || []; },
    referrals() { return (this.data && this.data.referrals) || []; },
    history() { return (this.data && this.data.history) || []; },
    fase5Diferida() {
      const fd = this.data && this.data.feature_disabled;
      return !!(fd && (fd.surveys || fd.events));
    }
  },
  watch: {
    customerId() { this.load(); }
  },
  mounted() { this.load(); },
  methods: {
    money(v) { const n = Number(v || 0); return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
    num(v) { return Number(v || 0); },
    load() {
      if (!this.customerId) return;
      this.loading = true;
      executiveService.customer360(this.customerId)
        .then((res) => { this.data = res.data || null; })
        .catch(() => { this.data = null; })
        .finally(() => { this.loading = false; });
    }
  }
}
</script>
